import { useState } from 'react';
import { ChromeTokens } from './tokens';
import { Icon } from './Icon';
import { mouseOnly } from './mouseOnly';

export interface InfoTipProps {
  text: string;
  size?: number;
}

/**
 * InfoTip — small info dot with a hover/focus tooltip bubble.
 */
export function InfoTip({ text, size = 16 }: InfoTipProps) {
  const [show, setShow] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}>
      <button
        aria-label="More info"
        onPointerEnter={mouseOnly(() => setShow(true))}
        onMouseLeave={() => setShow(false)}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        onClick={e => { e.preventDefault(); setShow(s => !s); }}
        style={{
          background: 'none', border: 'none', cursor: 'help', padding: 2,
          color: ChromeTokens.color.inkMuted, display: 'inline-flex',
        }}
      >
        <Icon name="info" size={size} />
      </button>
      {show && (
        <span role="tooltip" style={{
          position: 'absolute', bottom: 'calc(100% + 8px)', left: '50%', transform: 'translateX(-50%)',
          width: 250, background: ChromeTokens.color.ink, color: '#fdf6ec',
          fontSize: 12.5, lineHeight: 1.45, fontWeight: 500,
          padding: '10px 12px', borderRadius: 12, boxShadow: ChromeTokens.shadow.lifted,
          zIndex: 600, textAlign: 'left',
        }}>
          {text}
          <span style={{
            position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)',
            width: 0, height: 0, borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent', borderTop: `7px solid ${ChromeTokens.color.ink}`,
          }} />
        </span>
      )}
    </span>
  );
}
